<template>
  <v-list-item>
    <template #prepend>
      <v-icon
        v-if="channel.unsubscribedAt"
        color="red"
      >
        mdi-email-remove
      </v-icon>
      <v-icon
        v-else-if="isPaused"
        color="warning"
      >
        mdi-email-sync
      </v-icon>
      <v-icon
        v-else-if="channel.subscribedAt"
        color="success"
      >
        mdi-email-check
      </v-icon>
      <v-icon
        v-else
        color="orange"
      >
        mdi-email-lock
      </v-icon>
    </template>

    <v-list-item-title
      :class="[
        'py-1',
        'break-line',
        'd-flex',
        isActiveOrPaused
          ? 'flex-column align-start'
          : 'flex-row align-center justify-space-between',
      ]"
    >
      <span v-if="channel.unsubscribedAt">{{ $t('lead.base-info.channel.unsubscribed') }}</span>
      <span v-else-if="isPaused">{{ $t('lead.base-info.channel.paused') }}</span>
      <span v-else-if="channel.subscribedAt">{{ $t('lead.base-info.channel.subscribed') }}</span>
      <span v-else>{{ $t('lead.base-info.channel.invited') }}</span>

      <Permission permission="lead:unsubscribe">
        <ChannelStatusMenu
          v-if="isActiveOrPaused && !isLeadDeletedByCrmProvider"
          class="mt-2"
          :channel="channel"
          :lead-id="leadId"
        />
      </Permission>
      <Permission permission="lead:resubscribe">
        <ResendChannelDialog
          v-if="
            hasResendOptInFeature &&
            !channel.unsubscribedAt &&
            !channel.subscribedAt &&
            !isPaused &&
            !isLeadDeletedByCrmProvider
          "
          :channel="channel"
          :lead-id="leadId"
        />
      </Permission>
    </v-list-item-title>
  </v-list-item>
</template>

<script>
import Permission from '@/components/Permission'
import featureMixin from '@/mixins/feature'

import ChannelStatusMenu from './ChannelStatusMenu.vue'
import ResendChannelDialog from './ResendChannelDialog.vue'

export default {
  components: { ChannelStatusMenu, ResendChannelDialog, Permission },
  mixins: [featureMixin],
  props: {
    leadId: { type: String, required: true },
    channel: { type: Object, required: true },
    isLeadDeletedByCrmProvider: { type: Boolean, required: false },
  },
  computed: {
    hasResendOptInFeature() {
      return this.getFeature(this.featureNames.HOPPERMATION)?.config?.hasResendOptIn
    },
    isPaused() {
      return !!this.channel.pausedAt && !this.channel.unsubscribedAt
    },
    isActiveOrPaused() {
      return (
        !this.channel.unsubscribedAt && (!!this.channel.subscribedAt || !!this.channel.pausedAt)
      )
    },
  },
}
</script>

<style scoped>
.break-line {
  white-space: normal;
}
</style>
